import { Skeleton } from '@mantine/core';
import { SectionCard } from './SectionCard';

export function SectionSkeleton({
  label = 'Loading',
  rows = 4,
}: {
  label?: string;
  rows?: number;
}) {
  return (
    <div role="status" aria-label={label}>
      <SectionCard>
        <div className="flex items-center justify-between gap-2 px-1">
          <Skeleton height={28} width={160} radius="md" />
          <Skeleton height={16} width={96} radius="md" />
        </div>
        <div className="flex flex-col gap-2">
          {Array.from({ length: rows }, (_, i) => (
            <Skeleton key={i} height={52} radius="lg" />
          ))}
        </div>
      </SectionCard>
    </div>
  );
}
